import React, { useState, useEffect } from 'react';
import AsyncSelect from 'react-select/async';
import AxiosInstance from '../Axios';
import { CListGroup, CListGroupItem, CButton } from '@coreui/react';
import { confirmAlert } from 'react-confirm-alert';
// import { Link } from 'react-router-dom';

// Додавання категорій до варіації
const VariationsCategories = (props) => {
    // console.log("props", props);
    // props.variation_id - id-варіації

    const urlApi_1 = "/attribute_items";

    // Категорії, які додані до варіації
    const [catItem, setCatItem] = useState([]);
    // Категорії, які додані до варіації, записані у форматі PUT (`api/attribute_items/id`) для відправлення
    const [oldCat, setOldCat] = useState([]);
    // Вибрана категорія з пошуку
    const [selectedOption, setSelectedOption] = useState(null);
    // Текст для popup
    const popupTextPutSuccess = "Категорію додано";
    const popupTextDeleteSuccess = "Категорію видалено";
    const popupTextWarning = "Вибрана категорія вже належить до даної варіації";

    let i = 0;
    const handleChange = (selectedOption) => {
        setSelectedOption(selectedOption);
    };

    // Завантаження всіх категорій для вибору з випадаючого списку
    const loadOptions = async (inputValue) => {
        return await AxiosInstance.get('/categories', {
            headers: { 'accept': 'application/json' }, params: {
                name: inputValue
            }
        }).then((response) => {
            return response.data.map((result) => ({
                label: result.name,
                value: result.id,
            }));
        });
    };

    // Запит за категоріями, які вже додані до варіації
    const getParent = async () => {

        const ApiParams = {
            'g[1]': 'attributes_items:read',
            'g[2]': 'attributes_items:categories'
        }

        try {
            const response = await AxiosInstance.get(`${urlApi_1}/${props.variation_id}`,
                {
                    headers: { 'accept': 'application/json' },
                    params: ApiParams
                });
            // console.log("response get attribute_items", response);
            if (response.data?.categories?.length > 0) {
                setCatItem(response.data?.categories);
            };
        } catch (error) {
            console.error("Помилка запиту за варіацією: ", error);
        };
    };

    useEffect(() => {
        getParent();
    }, [props]);

    // console.log("catItem для варіації", catItem)

    // Заповнити категорії, які додані до варіації, записані у форматі PUT (`api/attribute_items/id`) для відправлення
    useEffect(() => {
        if (catItem?.length > 0) {
            let oldCategories = [];
            // Наповнити масив з категорями, перетвеними у формат для API
            catItem.map(el => oldCategories.push(`api/categories/${el.id}`));
            // console.log("oldCategories", oldCategories);
            setOldCat(oldCategories);
        }
        // console.log("catItem.categories", catItem);
    }, [catItem]);

    // Додати нову категорію
    const handleSave = () => {
        // Перевірка, чи вибрана категорія вже належить до даної варіації
        let enters = catItem?.length > 0 ? catItem.some(el => el.id == selectedOption.value) : false;
        if (enters) {
            // Popup про неуспішні зміни
            props.toastifyWarning(popupTextWarning);
        } else {
            // Вибрана нова категорія
            let newCategories = [`api/categories/${selectedOption.value}`];
            // Об'єднати старі категорії (якщо є) і нову категорію
            let categories = oldCat.length > 0 ? oldCat.concat(newCategories) : newCategories;
            // Дані, які підуть із запитом
            let article = {
                categories: categories
            };

            // Оновити категорії для варіації
            AxiosInstance.put(`/attribute_items/${props.variation_id}`, article).then((response) => {
                // console.log("response put", response);
                if (response.status == 200) {
                    getParent();
                    // Popup про успішні зміни
                    props.toastifySuccess(popupTextPutSuccess);
                }
            });
        };
    };

    // Видалити категорію від варіації
    const deleteCategory = (id) => {
        let categories = [];
        // Відфільтрувати категорію, яку потрібно видалити
        let filterCategories = catItem.filter(el => el.id !== id);
        // Наповнити масив з категорями, перетвеними у формат для API
        filterCategories.map(el => categories.push(`api/categories/${el.id}`));
        // Дані, які підуть із запитом
        let article = {
            categories: categories
        };

        // Оновити категорії для варіації
        AxiosInstance.put(`/attribute_items/${props.variation_id}`, article).then((response) => {
            // console.log("response put", response);
            if (response.status == 200) {
                getParent();
                // Popup про успішні зміни
                props.toastifySuccess(popupTextDeleteSuccess);
            }
        });
    };

    // Видалити категорію від варіації
    function Deleted(row) {
        confirmAlert({
            title: 'Ви впевнені що хочите видалити цей пункт ?',
            message: 'Are you sure to do this.',
            buttons: [
                {
                    label: 'Так',
                    onClick: () => {
                        // console.log("delete row id", row);
                        deleteCategory(row);
                    }
                },
                {
                    label: 'Ні',
                    onClick: () => {
                        return;
                    }
                }
            ]
        });
    };

    return (
        <>
            <div className="row">
                <div className="col"><h3>Категорії</h3></div>
                <div className="col d-flex">
                    <AsyncSelect
                        cacheOptions
                        loadOptions={loadOptions}
                        defaultOptions
                        value={selectedOption}
                        onChange={handleChange}
                        className="flex-grow-1 me-2"
                    />
                    <CButton onClick={handleSave} className="mb-2" color="secondary">+</CButton>
                </div>
            </div>

            {/* Список з доданими категоріями */}
            {
                (catItem?.length > 0) ?
                    <CListGroup className="mb-3">
                        {
                            catItem.map((v, k) => {
                                i++;
                                return (
                                    <CListGroupItem key={k} className="d-flex justify-content-between align-items-center">
                                        {/* <Link to={`/products/update/${v.id}`} >{`${i})`} {v.name}</Link> */}
                                        {`${i})`} {v.name}
                                        <CButton color="danger" variant="outline" onClick={() => { Deleted(v.id) }}>
                                            Видалити
                                        </CButton>
                                    </CListGroupItem>
                                )
                            })
                        }
                    </CListGroup>
                    :
                    <p className="ml-3">Категорій не знайдено</p>
            }
        </>
    );
}

export default VariationsCategories;